import { ResponsivePieCanvas } from '@nivo/pie';
import { useMediaQuery, useTheme } from '@mui/material';

const PieChart = ({ plans }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const isMobile = useMediaQuery('(max-width:600px)');

  const pieData = Object.entries(plans || {})
    .map(([name, value]) => ({
      id: name,
      label: name,
      value: Number(value),
    }))
    .filter(item => item.value > 0);

  if (pieData.length === 0) {
    return <p>No subscription plan data available.</p>;
  }

  const textColor = isDarkMode ? '#1a1919ff' : '#7e7e78';

  return (
    <div style={{ height: isMobile ? 300 : 315, width: '100%' }}>
    <ResponsivePieCanvas
  data={pieData}
  margin={{
    top: 40,
    right: isMobile ? 20 : 200,
    bottom: 40,
    left: isMobile ? 20 : 80,
  }}
  innerRadius={0.5}
  padAngle={0.6}
  cornerRadius={2}
  activeOuterRadiusOffset={8}
  colors={{ scheme: 'paired' }}
  arcLinkLabelsSkipAngle={10}
  arcLinkLabelsTextColor={textColor}
  arcLinkLabelsThickness={2}
  arcLinkLabelsColor={{ from: 'color' }}
  arcLabelsSkipAngle={10}
  arcLabelsTextColor={textColor}
  tooltip={({ datum }) => (
    <div
      style={{
        padding: '6px 10px',
        borderRadius: '4px',
        background: isDarkMode ? '#333' : '#fff',
        color: isDarkMode ? '#fff' : '#000',
        fontSize: '12px',
        boxShadow: '0px 0px 6px rgba(0,0,0,0.3)',
      }}
    >
      <strong>{datum.id}</strong>: {datum.value}
    </div>
  )}
  legends={
    isMobile
      ? []
      : [
          {
            anchor: 'right',
            direction: 'column',
            translateX: 140,
            itemsSpacing: 2,
            itemWidth: 100,
            itemHeight: 20,
            itemTextColor: textColor,
            symbolSize: 12,
          },
        ]
  }
/>
    </div>
  );
};

export default PieChart;
